import PageLayout from "@components/PageLayout";
import { HighGrowthVault } from "@components/V2/Vault";

const YieldVaultPage = () => {
  return (
    <PageLayout extraMarginTop={false}>
      <HighGrowthVault />
    </PageLayout>
  );
};

export default YieldVaultPage;
